import callWebGate from './callWebGate';

const SPOTIFY_WEB_API = `https://api.spotify.com/v1`;

export function getUserInfo(accessToken) {
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + accessToken);

  const opts = {
    headers,
  };

  return fetch(`${SPOTIFY_WEB_API}/me`, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}

export function getUserGroups(accessToken, webGate = callWebGate) {
  const url = 'adgenerator/v1/usergroups';
  return webGate(url, accessToken)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}

export function getUserData(accessToken) {
  const url = 'adgenerator/v1/account/userdata';
  return callWebGate(url, accessToken)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}

export function getGAPartnerUserId(accessToken) {
  const url = 'partner-userid/encrypted/googleanalytics-adstudio';
  return callWebGate(url, accessToken, undefined, 'prod')
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.text();
    });
}



// WEBPACK FOOTER //
// ./src/api/user.js